<template>
	<v-dialog
		:value="dialog"
		max-width="100%"
		@input="$emit('close-modal', $event)"
	>
		<div>
			<v-card class="new-survey open-modal">
				<slot></slot>
			</v-card>
			<div class="background-footer-modal" v-if="footer">
				<v-layout wrap justify-center>
					<v-flex xs2 mx-1>
						<v-btn
							:color="color"
							type="button"
							class="btn btn-action btn-disabled-background"
							:disabled="create"
							@click="$emit('create-employee')"
						>
							{{ title }}
						</v-btn>
					</v-flex>
				</v-layout>
			</div>
		</div>
	</v-dialog>
</template>

<script>
export default {
	name: 'open-modal',
	props: {
		dialog: {
			type: Boolean,
			default: false,
		},
		create: {
			type: Boolean,
			default: true,
		},
		footer: {
			default: true,
			type: Boolean,
		},
		title: {
			type: String,
			default: '',
		},
		color: {
			type: String,
			default: 'primary',
		},
	},
};
</script>

<style lang="scss" scoped>
.open-modal{
	background-color: map-get($colors, gray-light);
	box-shadow: 0 2px 21px 0 rgba(68, 68, 68, 0.5);
	position: relative;
	width: 100%;
}

.background-footer-modal {
	background-color: map-get($colors, white);
	bottom: 0;
	left: 0;
	padding: 19px;
	position: absolute;
	width: 100%;
}

.v-dialog {
	margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/open-modal.vue